import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useOnboarding } from '../context/OnboardingContext';

export function useSectionCompletion(sectionId: string) {
  const navigate = useNavigate();
  const location = useLocation();
  const { getSectionById } = useOnboarding();

  const section = getSectionById(sectionId);
  const locationState = location.state as { from?: string; portalPath?: string } | null;
  const cameFromPortal = locationState?.from === 'portal';
  const portalPath = locationState?.portalPath;

  const returnToDashboard = useCallback(() => {
    navigate(cameFromPortal && portalPath ? portalPath : cameFromPortal ? '/dashboard' : '/onboarding');
  }, [navigate, cameFromPortal, portalPath]);

  return {
    section,
    returnToDashboard,
    cameFromPortal,
  };
}
